import React, { useState, useEffect } from "react";
import { Formik, useField } from "formik";
import * as yup from "yup";
import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Card,
  Typography,
  MenuItem,
  FormHelperText,
  InputLabel,
  FormControl,
  Select,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,Tooltip,Collapse,InputAdornment
} from "@mui/material";
import { styled } from "@mui/material/styles";
import swal from "sweetalert";
import Swal from "sweetalert2";
import imageCompression from "browser-image-compression";
import { PDFDocument } from "pdf-lib";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useAuth } from "../../../AuthProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import SettingsIcon from "@mui/icons-material/Settings";
import axios from "axios";
import {ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import * as XLSX from "xlsx";


import { tooltipClasses } from '@mui/material';

const FancyTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    background: 'linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)',
    color: '#fff',
    fontSize: 14,
    fontWeight: 500,
    padding: theme.spacing(1.2, 2),
    borderRadius: 8,
    boxShadow: '0 0 10px rgba(106, 17, 203, 0.7)',
    animation: 'tooltipFadeIn 0.5s ease-in-out',
  },
  '@keyframes tooltipFadeIn': {
    from: { opacity: 0, transform: 'translateY(-5px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
  },
}));







// Define styled components
const StyledTextField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

const FacebookCircularProgress = styled(CircularProgress)({
  color: "#3b5998",
});

const states = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Other",
];

const NewAdmissionForm = () => {
  const { userId, role ,oId,board,pId} = useAuth(); // Access userId from AuthContext
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const [currentTab, setCurrentTab] = useState(0);
  const [loading, setLoading] = useState(false);
 const [excelloading, setExcelLoading] = useState(false);  
  const navigate = useNavigate();
  const [academicYears, setAcademicYears] = useState([]);

  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState("");
  const isPrincipal = role?.startsWith("PRINCIPAL") || false;



const [open, setOpen] = useState(false);
const [studentPrefixId, setPrefix] = useState("");
const [isPrefixDisabled, setIsPrefixDisabled] = useState(false); // control disable state separately

const [sequenceNumber, setSequenceNumber] = useState("");
const [loadingSettings, setLoadingSettings] = useState(true);
const [companyInfo, setCompanyInfo] = useState({});
const [getcompanyInfo, setGetCompanyInfo] = useState({});
const [dialogSubmitted, setDialogSubmitted] = useState(false); // ⬅️ new flag

const handleOpen = () => setOpen(true);
const handleClose = () => setOpen(false);


 const [excelData, setExcelData] = useState([]);
  const [fileName, setFileName] = useState("");


//   const [classSectionData, setClassSectionData] = useState([]);
// const [classOptions, setClassOptions] = useState([]);
// const [sectionOptions, setSectionOptions] = useState([]);
// const [courseOptions, setCourseOptions] = useState([]);
// const [selectedCourseType, setSelectedCourseType] = useState("");

const [sscClassOptions, setSscClassOptions] = useState([]);
const [sscSectionOptions, setSscSectionOptions] = useState([]);
const [sscSelectedClass, setSscSelectedClass] = useState();
const [sscSelectedSection, setSscSelectedSection] = useState();

// INTERMEDIATE states
const [interSectionOptions, setInterSectionOptions] = useState([]);
const [interSelectedClass, setInterSelectedClass] = useState();
const [interSelectedSection, setInterSelectedSection] = useState();
const [courseOptions, setCourseOptions] = useState([]);
const [selectedCourseType, setSelectedCourseType] = useState("");


const [sscClassSectionMap, setSscClassSectionMap] = useState({});

const [uploadProgress, setUploadProgress] = useState(0);
const [progressInterval, setProgressInterval] = useState(null);




// -------------------------------------------
//           For SSC functions
// -------------------------------------------

// ---- Fetch Class + Sections for SSC (School) ----
// const fetchClassRegistrationData = async () => {
//   try {
//     const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`);
//     const data = await response.json();
//     if (response.ok && Array.isArray(data)) {
//       // setSscClassSectionData(data);
//       const classes = data.map(item => item.classRegistration);
//       setSscClassOptions(classes);

//       let defaultClass = sscSelectedClass || (classes.includes("Class-I") ? "Class-I" : classes[0] || "");
//       setSscSelectedClass(defaultClass);

//       const defaultClassData = data.find(item => item.classRegistration === defaultClass);
//       if (defaultClassData) {
//         const sections = defaultClassData.sections.split(",");
//         setSscSectionOptions(sections);
//         setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0]);
//       } else {
//         setSscSectionOptions([]);
//         setSscSelectedSection("");
//       }
//     }
//   } catch (error) {
//     console.error("Error fetching SSC data:", error);
//   }
// };
const fetchClassRegistrationData = async () => {
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`);
    const data = await response.json();

    if (response.ok && Array.isArray(data)) {
      // Group by class and merge section strings into unique values
      const classSectionMap = {};

      data.forEach(item => {
        const className = item.classRegistration;
        const sectionList = item.sections.split(",").map(s => s.trim());

        if (!classSectionMap[className]) {
          classSectionMap[className] = new Set();
        }

        sectionList.forEach(section => classSectionMap[className].add(section));
      });

      const classes = Object.keys(classSectionMap);
      setSscClassOptions(classes); // Class dropdown options
      setSscClassSectionMap(classSectionMap); // Save for section filtering later

      // No default selection
      setSscSelectedClass("");
      setSscSelectedSection("");
      setSscSectionOptions([]);
    }
  } catch (error) {
    console.error("Error fetching SSC data:", error);
  }
};



// -------------------------------------------
//           For Intermediate functions
// -------------------------------------------

// ---- Fetch Courses for INTERMEDIATE ----
const fetchCourseData = async () => {
    if(!interSelectedClass) return;
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllcoursesAccordingClasses/${pId}?romanNumberClass=${interSelectedClass}`);
    const data = await response.json();
    if (response.ok && Array.isArray(data)) {
      setCourseOptions(data);
      // if (!selectedCourseType) {
      //   setSelectedCourseType(data || "");
      // }
    } else {
      setCourseOptions([]);
    }
  } catch (error) {
    console.error("Error fetching course data:", error);
    setCourseOptions([]);
  }
};

// ---- Fetch Sections for INTERMEDIATE ----
const fetchSectionsData = async () => {
  if (!interSelectedClass || !selectedCourseType) {
    setInterSectionOptions([]);
    return;
  }
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/getAllClass-registrations/${interSelectedClass}/${selectedCourseType}/${pId}`
    );
    const data = await response.json();
    if (response.ok && Array.isArray(data) && data.length > 0) {
      const sectionsString = data[0].sections;  // because your data is like [{ sections: "Section-A,Section-B" }]
      const sections = sectionsString.split(",").map(section => section.trim());
     
      setInterSectionOptions(sections);

      if (sections.length > 0) {
        setInterSelectedSection(sections[0]);
      } else {
        setInterSelectedSection("");
      }
    } else {
      setInterSectionOptions([]);
      setInterSelectedSection("");
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE data:", error);
  }
};





useEffect(() => {
  const loadClassData = async () => {
    if (board === "INTERMEDIATE") {
      await fetchSectionsData();
    } else if (board === "SSC") {
      await fetchClassRegistrationData();
    }
  };
  loadClassData();
}, [board,interSelectedClass, selectedCourseType, oId]);  // Removed selectedClass dependency here







// Fetch course options if board is INTERMEDIATE
useEffect(() => {
  if (board === "INTERMEDIATE") {
    fetchCourseData();
  }
}, [interSelectedClass,board, oId]);


// Fetch org info and settings
const fetchCompanyInfo = async () => {
  try {
    const response = await fetch(`${baseUrl}/api/principal/pr/getById/${pId}`);
    if (!response.ok) {                    
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    setGetCompanyInfo(data);
    setCompanyInfo(data);

    // // ✅ pull prefix/sequence from the API response
    // setPrefix(data.studentPrefixId || "");
    // setSequenceNumber(data.sequenceNumber || "");
    // Set the prefix only if coming from API
    if (data.studentPrefixId) {
      setPrefix(data.studentPrefixId);
      setIsPrefixDisabled(true); // Disable only if value came from backend
    }

    setSequenceNumber(data.sequenceNumber || "");

    setLoadingSettings(false); // ✅ done loading
  } catch (error) {
    console.error("Error fetching company info:", error);
    setLoadingSettings(false); // Even on error, avoid infinite loading
  }
};

useEffect(() => {
  fetchCompanyInfo();
}, [oId]);

// Show dialog only ONCE if settings are missing
useEffect(() => {
  if (!loadingSettings && !dialogSubmitted) {
    if (!studentPrefixId || !sequenceNumber) {
      setOpen(true); // only the first time
    }
  }
}, [loadingSettings, studentPrefixId, sequenceNumber, dialogSubmitted]);


const handlePrefixSubmit = async () => {
  try {
    const queryParams = new URLSearchParams({ studentPrefixId, sequenceNumber });

    const response = await fetch(
      `${baseUrl}/api/principal/update/settings/${oId}/${pId}?${queryParams.toString()}`,
      { method: "PATCH" }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Error submitting:", response.statusText, errorText);
      toast.error(`${response.statusText} ${errorText}`);
      return;
    }

    const data = await response.json();
    setCompanyInfo(data);
    setDialogSubmitted(true); // ✅ prevent future auto-open
    toast.success("Prefix and Sequence updated successfully!", {
      autoClose: 1000,
    });

    fetchCompanyInfo(); // optional re-fetch
    handleClose();
  } catch (error) {
    toast.error("Failed to update sequence. Please try again.");
    console.error("Fetch error:", error);
  }
};




  // Validation schema using yup
  const validationSchemaTab0 = yup.object().shape({
    // Basic Details

    religion: yup
      .string()
      // .required(" Religion is required")
      .matches(/^[a-zA-Z\s]+$/, "Religion can only contain letters"),
    firstName: yup
      .string()
      .required("First Name is required")
      .matches(/^[a-zA-Z\s]+$/, "First Name can only contain letters"),
    lastName: yup
      .string()
      .required("Last Name is required")
      .matches(/^[a-zA-Z\s]+$/, "Last Name can only contain letters"),
    // email: yup
    //   .string()
    //   .email("Invalid email format")
    //   .required("Email is required"),
    // contactNumber1: yup
    //   .string()
    //   .required("Contact Number is required")
    //   .matches(/^\d+$/, "Contact Number can only contain numbers")
    //   .matches(/^[0-9]{10}$/, "Contact Number must be exactly 10 digits"),

    // gender: yup.string().required("Gender is required"),
    // bloodGroup: yup.string().required("bloodGroup is required"),
    bloodGroup: yup
      .string()
      .oneOf(
        ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-", "None"],
        "Invalid blood group"
      ),
      // .required("Blood group is required"),

    // dob: yup
    //   .date()
    //   .required("Date of Birth is required")
    //   .max(new Date(), "Date of Birth cannot be in the future"),

    // admissionDate: yup.date().required("Admission Date is required"),
    // studentJoinedYear: yup.date().required("Student Joining Year is required"),

    // nationality: yup.string().required("Nationality is required"),
    nationality: yup
      .string()
      .oneOf(["Indian", "Other"], "Invalid nationality"),
      // .required("Nationality is required"),

    // workEmail: yup
    //   .string()
    //   .email("Invalid email format")
    //   .required("Work Email is required"),
    // joiningDate: yup
    //   .date()
    //   .required("Joining Date is required")
    //   .max(new Date(), "Joining Date cannot be in the future"),

    // caste: yup.string().required("Caste is required"),
    caste: yup
      .string()
      // .required(" caste is required")
      .matches(/^[a-zA-Z\s-]+$/, "caste can only contain letters"),
  });

  const validationSchemaTab1 = yup.object().shape({
    // aadharNumber: yup
    //   .string()
    //   // .required("Aadhar Number is required")
    //   .test(
    //     "is-12-digits",
    //     "Aadhar Number must be exactly 12 digits",
    //     (value) => /^\d{12}$/.test(value) // Ensures exactly 12 digits
    //   )
    //   .test(
    //     "is-not-negative",
    //     "Invalid Aadhar Number",
    //     (value) => !/^-\d+$/.test(value) // Prevents negative numbers
    //   ),

    romanNumberClass: yup.string().required("Student Present  is required"),
    // studentJoinedClass: yup
    //   .string()
    //   .required("Student Joined Class  is required"),
    sections: yup.string().required("Section  is required"),

    // previousSchool: yup.string().required("Previous School is required"),

    // previousSchool: yup
    //   .string()
    //   .required(" previous Studied is required")
    //   .matches(/^[a-zA-Z\s]+$/, "previousStudied can only contain letters"),

    // .matches(/^[0-9]{12}$/, "Aadhar Number must be exactly 12 digits"),
    primaryContact: yup
      .string()
      .required("PrimaryContact Number is required")
      .matches(/^\d+$/, "PrimaryContact Number can only contain numbers")
      .matches(
        /^[0-9]{10}$/,
        "PrimaryContact Number must be exactly 10 digits"
      ),

    // address: yup.string().required(" address is required"),

    // mole1: yup
    //   .string()
    //   .required(" MOLE-1 is required")
    //   .matches(/^[a-zA-Z\s]+$/, "MOLE-1 can only contain letters"),

    // mole2: yup
    //   .string()
    //   .required(" MOLE-2 is required")
    //   .matches(/^[a-zA-Z\s]+$/, "MOLE-2 can only contain letters"),

    alternateContact: yup
      .string()
      // .required("Mother Number is required")
      .matches(/^\d+$/, "Mother Number can only contain numbers")
      .matches(/^[0-9]{10}$/, "Mother Number must be exactly 10 digits"),
  });
  const validationSchemaTab2 = yup.object().shape({
    fathersQualification: yup
      .string()
      // .required("Higher Qualification is required")
      .matches(/^[a-zA-Z\s]+$/, "Qualification can only contain letters")
      .max(50, "Qualification can't be longer than 50 characters"),

    fathersOccupation: yup
      .string()
      // .required("fathersOccupation is required")
      .matches(/^[a-zA-Z\s]+$/, "fathersOccupation can only contain letters"),

    fathersMailId: yup
      .string()
      .email("Invalid email address"), // Ensures proper email format
      // .required("Father's Email ID is required"),

    mothersMailId: yup
      .string()
      .email("Invalid email address") ,// Ensures proper email format
      // .required("mother's Email ID is required"),

    mothersQualification: yup
      .string()
      // .required("Higher Qualification is required")
      .matches(/^[a-zA-Z\s]+$/, "Qualification can only contain letters")
      .max(50, "Qualification can't be longer than 50 characters"),

    mothersOccupation: yup
      .string()
      // .required("Father First Name is required")
      .matches(/^[a-zA-Z\s]+$/, "Father First Name can only contain letters"),

    fathersFirstName: yup
      .string()
      // .required("Father First Name is required")
      .matches(/^[a-zA-Z\s]+$/, "Father First Name can only contain letters"),

    fathersLastName: yup
      .string()
      // .required("Father Last Name is required")
      .matches(/^[a-zA-Z\s]+$/, "Father Last Name can only contain letters"),

    mothersFirstName: yup
      .string()
      // .required("Mother First Name is required")
      .matches(/^[a-zA-Z\s]+$/, "Mother First Name can only contain letters"),

    mothersLastName: yup
      .string()
      // .required("Mother Last Name is required")
      .matches(/^[a-zA-Z\s]+$/, "Mother Last Name can only contain letters"),
  });
  const validationSchemaTab4 = yup.object().shape({
    bankName: yup
      .string()
      // .required("Bank Name is required")
      .matches(/^[A-Za-z\s]+$/, "Bank Name can only contain letters")
      .max(100, "Bank Name cannot exceed 100 characters"),

    bankAccount: yup
      .string()
      // .required("Bank Account Number is required")
      .matches(
        /^\d{9,18}$/,
        "Bank Account Number must be between 9 and 18 digits"
      ),

    ifscCode: yup
      .string()
      // .required("IFSC Code is required")
      .matches(
        /^[A-Z]{4}0[A-Z0-9]{6}$/,
        "IFSC Code must be in capital letters and numbers"
      ),

    bankBranch: yup
      .string()
      // .required("Bank Branch is required")
      .matches(/^[A-Za-z\s]+$/, "Bank Branch can only contain letters")
      .max(100, "Bank Branch cannot exceed 100 characters"),
  });
  const validationSchemaTab5 = yup.object().shape({
    // passPhoto: yup
    //   .mixed()
    //   // .required("Profile picture is required")
    //   .test("fileSize", "File size should be less than 1MB", (value) => {
    //     return value && value.size <= 1024 * 1024; // 1MB in bytes
    //   })
    //   .test(
    //     "fileFormat",
    //     "Unsupported file format. Only JPG, JPEG, and PNG are allowed",
    //     (value) => {
    //       return (
    //         value &&
    //         ["image/jpeg", "image/jpg", "image/png"].includes(value.type)
    //       );
    //     }
    //   ),
     // Pass-photo is **optional**; validate it only when a file is present.
  passPhoto: yup
    .mixed()
    .nullable()
    .test('fileSize', 'File size should be less than 1 MB', (value) => {
      if (!value) return true;              // ⬅️  no file → skip rule
      return value.size <= 1024 * 1024;
    })
    .test(
      'fileFormat',
      'Unsupported file format. Only JPG, JPEG, and PNG are allowed',
      (value) => {
        if (!value) return true;            // ⬅️  no file → skip rule
        return ['image/jpeg', 'image/jpg', 'image/png'].includes(value.type);
      }
    ),

    // aadharCard: yup
    //   .mixed()
    //   // .required("aadharCard is required")
    //   .test(
    //     "fileType",
    //     "Only .jpg, .jpeg, .png, .pdf files are allowed",
    //     (value) =>
    //       value &&
    //       ["application/pdf", "image/jpeg", "image/png"].includes(value.type)
    //   )
    //   .test(
    //     "fileSize",
    //     "File must be less than 1 MB",
    //     (value) => value && value.size <= 1024 * 1024 // 1 MB in bytes
    //   ),

    // dobCertificate: yup
    //   .mixed()
    //   // .required("Date Of Birth Certificate is required")
    //   .test(
    //     "fileType",
    //     "Only .jpg, .jpeg, .png, .pdf files are allowed",
    //     (value) =>
    //       value &&
    //       ["application/pdf", "image/jpeg", "image/png"].includes(value.type)
    //   )
    //   .test(
    //     "fileSize",
    //     "File must be less than 1 MB",
    //     (value) => value && value.size <= 1024 * 1024 // 1 MB in bytes
    //   ),

    // previousTc: yup
    //   .mixed()
    //   // .required("previousTc is required")
    //   .test(
    //     "fileType",
    //     "Only .jpg, .jpeg, .png, .pdf files are allowed",
    //     (value) =>
    //       value &&
    //       ["application/pdf", "image/jpeg", "image/png"].includes(value.type)
    //   )
    //   .test(
    //     "fileSize",
    //     "File must be less than 1 MB",
    //     (value) => value && value.size <= 1024 * 1024 // 1 MB in bytes
    //   ),

    // bonafide: yup
    //   .mixed()
    //   // .required("bonafide is required")
    //   .test(
    //     "fileType",
    //     "Only .jpg, .jpeg, .png, .pdf files are allowed",
    //     (value) =>
    //       value &&
    //       ["application/pdf", "image/jpeg", "image/png"].includes(value.type)
    //   )
    //   .test(
    //     "fileSize",
    //     "File must be less than 1 MB",
    //     (value) => value && value.size <= 1024 * 1024 // 1 MB in bytes
    //   ),

    // tutionFee: yup.string().required("school Fee is required"),

    // admissionFee: yup.string().required("Admission Fee is required"),
    // Fees must be provided
  admissionFee: yup
    .number()
    .typeError('Admission Fee is required')
    .positive('Admission Fee must be positive'),
    // .required('Admission Fee is required'),

  tutionFee: yup
    .number()
    .typeError('School Fee is required')
    .positive('School Fee must be positive')
    // .required('School Fee is required'),
  });

  const getValidationSchema = () => {
    switch (currentTab) {
      case 0:
        return validationSchemaTab0;
      case 1:
        return validationSchemaTab1;
      case 2:
        return validationSchemaTab2;
      //   case 4:
      //     return validationSchemaTab4;
      case 3:
        return validationSchemaTab5;
      // Add cases for other tabs if needed
      default:
        return validationSchemaTab0; // Default schema
    }
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(
          `${baseUrl}/api/principal/getAllUserIdsAndNames/ADMISSION_FEE/${oId}/${pId}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch users");
        }
        const data = await response.json();
        setUsers(data);
        if (data.length > 0) {
          setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    fetchUsers();
  }, []);



  const handleSubmit = async (values) => {
    // Show confirmation dialog
    const result = await Swal.fire({
      title: 'Add New Student',
      text: "Are you sure you want to add new Student?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
    });
 
    if (result.isConfirmed) {
      setLoading(true);
      try {
       
          const sanitizedValues = { ...values };
      Object.keys(sanitizedValues).forEach((key) => {
        if (sanitizedValues[key] === '' || sanitizedValues[key] === 'null') {
          sanitizedValues[key] = null;
        }
      });

      // Add +91 prefix to primaryContact if it exists and not already prefixed
      // if (sanitizedValues.primaryContact) {
      //   const c = sanitizedValues.primaryContact.toString();
      //   sanitizedValues.primaryContact = c.startsWith("91") ? c : `91${c}`;
      // }
      if (sanitizedValues.primaryContact) {
  let c = sanitizedValues.primaryContact.toString().replace(/\D/g, ''); // keep digits only

  if (c.length === 10) {
    // It's a normal 10-digit number, add country code
    sanitizedValues.primaryContact = `91${c}`;
  } else if (c.length === 12 && c.startsWith("91")) {
    // Already in +91 format (country code), keep as is
    sanitizedValues.primaryContact = c;
  } else {
    // Invalid number (e.g. 11 digits, wrongly formatted), handle as needed
    sanitizedValues.primaryContact = null;
  }
}


      const formData = new FormData();

      const compressFile = async (file) => {
        if (!file) return file;

        if (file.type.startsWith('image/')) {
          const options = { maxSizeMB: 1, maxWidthOrHeight: 1024 };
          return await imageCompression(file, options);
        } else if (file.type === 'application/pdf') {
          const pdfDoc = await PDFDocument.load(await file.arrayBuffer());
          const compressedPdf = await pdfDoc.save();
          return new Blob([compressedPdf], { type: 'application/pdf' });
        }
        return file;
      };

      const handleFile = async (key, file) => {
        const compressedFile = await compressFile(file);
        formData.append(key, compressedFile);
      };

      await Promise.all(
        Object.keys(sanitizedValues).map(async (key) => {
          if (sanitizedValues[key] && sanitizedValues[key] instanceof File) {
            await handleFile(key, sanitizedValues[key]);
          } else if (sanitizedValues[key] !== null) {
            formData.append(key, sanitizedValues[key]);
          }
        })
      );
 
        const UserId = userId || selectedUsers;
        const apiEndpoint = `${baseUrl}/api/staffUserAdmission/saveStudent/${UserId}`;
 
        const response = await fetch(apiEndpoint, {
          method: 'POST',
          body: formData,
        });

        const responseData = await response.json(); // ✅ Parse response JSON only once
 
        if (response.ok) {
          // Show success toast message
          toast.success('Student Registered Successfully', {
            position: "top-right",
            autoClose: 1000,
          });
         
 
        }
       
        else {
          const errorMessage = responseData?.error_message || "Error submitting the form.";
                   console.error("Error submitting the form:", errorMessage);
         
                   toast.error(errorMessage, {
                     position: "top-right",
                     autoClose: 2000,
                   });
   
        }
      } catch (error) {
        console.error('Error submitting the form', error);
        // Show error toast message
        toast.error('An unexpected error occurred while submitting the form.', {
          position: "top-right",
          autoClose: 1000,
        });
      } finally {
        setLoading(false);
      }
    }
  };
 

  // Initial form values
  const initialValues = {
    //Basic

    firstName: "",
    lastName: "",
    gender: "",
    dob: "",
    admissionDate: "",
    customAdmissionNumber:"",
    studentJoinedYear: "",
    nationality: "",
    pen:"",
    religion: "",
    caste: "",

 

    city: "",
    state: "",
    bloodGroup: "",
    role: "STUDENT",

    //Personal Deatils
    panNumber: "",
    aadharNumber: "",
    mole1: "",
    mole2: "",
    studentJoinedClass: "",
    romanNumberClass: "",
    sections: "",
    course:"",
    previousSchool: "",
    primaryContact: "",
    alternateContact: "",
    address: "",

    //Family Details
    fathersFirstName: "",
    fathersLastName: "",
    mothersFirstName: "",
    mothersLastName: "",
    maritalStatus: "",
    fathersQualification: "",
    mothersQualification: "",
    fathersOccupation: "",
    mothersOccupation: "",
    fathersMailId: "",
    mothersMailId: "",

    //Documents
    passPhoto: null,
    aadharCard: null,
    dobCertificate: null,
    bonafide: null,
    previousTc: null,
    tutionFee: "",
    admissionFee: "",
  };

  const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" },
  ];

  useEffect(() => {
    const generateAcademicYears = () => {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth() + 1; // JavaScript months are 0-based

      const years = [];

      for (let year = 2000; year < currentYear; year++) {
        years.push(`${year}-${year + 1}`);
      }

      // Add current academic year if it’s not already the latest
      const lastGeneratedYear = `${currentYear - 1}-${currentYear}`;
      if (!years.includes(lastGeneratedYear)) {
        years.push(lastGeneratedYear);
      }

      // Add next academic year **only if the current month is May (5) or later**
      const nextYear = `${currentYear}-${currentYear + 1}`;
      if (currentMonth >= 5 && !years.includes(nextYear)) {
        years.push(nextYear);
      }

      return years.reverse(); // Show latest year first
    };

    setAcademicYears(generateAcademicYears());
  }, []);



  const [showTooltip, setShowTooltip] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowTooltip(false), 10000); // Hide after 10s
    return () => clearTimeout(timer);
  }, []);


  // const schoolTitle =getcompanyInfo.schoolName?.slice(0, 3)?.toUpperCase() || "SCH";
const schoolTitle = (() => {
  const name = getcompanyInfo.schoolName || "";
  const firstWord = name.trim().split(" ")[0] || "";
  return firstWord.length <= 2
    ? firstWord.toUpperCase()
    : firstWord.slice(0, 3).toUpperCase();
})();



useEffect(() => {
  if (getcompanyInfo?.schoolName) {
    const name = getcompanyInfo.schoolName.trim().split(" ")[0] || "";
    const defaultPrefix = name.length <= 2
      ? name.toUpperCase()
      : name.slice(0, 3).toUpperCase();

    if (!studentPrefixId) setPrefix(defaultPrefix);
    if (!sequenceNumber) setSequenceNumber("100");
  }
}, [getcompanyInfo]);





// excel functionality code


 const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) {
      setFileName("Upload Excel");
    return;
    }
   

    setFileName(file.name); // show filename
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const parsedData = XLSX.utils.sheet_to_json(sheet);

      // Convert all string values to uppercase
    const upperCasedData = parsedData.map((row) => {
      const upperRow = {};
      Object.entries(row).forEach(([key, value]) => {
        upperRow[key] = typeof value === "string" ? value.toUpperCase() : value;
      });
      return upperRow;
    });

      setExcelData(parsedData);
    };
    reader.readAsArrayBuffer(file);
  };




const handleExcelSubmit = async () => {
  if (excelData.length === 0) {
    toast.error("Please upload an Excel file first.");
    return;
  }

  setExcelLoading(true);

  try {
    const UserId = userId || selectedUsers;

    const response = await fetch(
      `${baseUrl}/api/staffUserAdmission/saveMultipleStudents/${UserId}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(excelData),
      }
    );

    if (response.ok) {
      toast.success("Excel data uploaded successfully!", {
        position: "top-right",
        autoClose: 1000,
        onClose: () => navigate("/AllStudentList"),
      });
    } else {
      const error = await response.json();

      // If error is an array of strings, join them nicely
      if (Array.isArray(error)) {
        toast.error(
          error.join("\n"),
          { autoClose: 2000 }
        );
      } else if (typeof error === "string") {
        toast.error(error);
      } else {
        toast.error("Upload failed with unknown error.");
      }

      console.error("Upload failed:", error);
    }
  } catch (err) {
    console.error("Error submitting:", err);
    toast.error("Something went wrong.");
  } finally {
    setExcelLoading(false);
  }
};







  return (
    <Box marginTop={9}>
      <Formik
        initialValues={initialValues}
        validationSchema={getValidationSchema()}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          validateForm,
          setFieldValue,
          setTouched,
        }) =>
          {
           

         return (
          <form
            onSubmit={(e) => {
              e.preventDefault(); // Prevent the default form submission behavior
              handleSubmit(values); // Call the handleSubmit function with form values
            }}
          >
            <Box display="flex" flexDirection="column" alignItems="center">
              <Card
                sx={{
                  padding: 2,
                  backgroundColor: "#fff",
                  width: "96%",
                  height: "60%",
                }}
              >
                 <Box mb={4}>
     


      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
  {/* Empty spacer to balance the flex layout */}
  <Box width="33%" />

  {/* Centered Heading */}
  <Box width="33%" textAlign="center">
    <Typography variant="h4" sx={{ fontWeight: "bold" }}>
      Student Admission Form
    </Typography>
  </Box>

  {/* Right-aligned Settings Button */}
  <Box width="33%" display="flex" justifyContent="flex-end">
    <Button
      startIcon={<SettingsIcon />}
      variant="outlined"
      color="primary"
      onClick={handleOpen}
      className="pulse-button"
    >
      Settings
    </Button>
  </Box>
</Box>






 
     
     




 
<Dialog
  open={open}
  onClose={handleClose}
  PaperProps={{ sx: { backgroundColor: "#f3f6f9", borderRadius: 2 } }}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle
    sx={{
      bgcolor: "#1976d2",
      color: "#fff",
      textAlign: "center",
      fontWeight: 600,
    }}
  >
    Configure Form Settings
  </DialogTitle>

  <DialogContent dividers sx={{ p: 3 }}>
    <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
      Define the Student ID format by entering a prefix and a sequence number. This helps
      auto-generate unique Student IDs like Below:
    </Typography>

   
    <Box
  sx={{
    mb: 3,
    p: 2,
    bgcolor: "#fffbea",
    borderRadius: 1,
    border: "1px solid #f0e68c",
    fontFamily: "monospace",
    fontSize: "1rem",
    color: "#333",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 1,
  }}
>
  <div>
    <strong>Example Student ID:</strong>{" "}
    {`${studentPrefixId || "ABC"}-${getcompanyInfo.entity || "STUD"}-${sequenceNumber || "100"}`}
  </div>

  <div>
    <strong>Admission Sequence Number Starts From:</strong>{" "}
    {`${sequenceNumber || "100"}`}
  </div>
</Box>


    <Tooltip title="Enter a short code like ADM, REG, FEE, etc.">
      {/* <TextField
        fullWidth
        label="Prefix"
        placeholder="e.g., ADM"
        value={studentPrefixId}
        onChange={(e) => setPrefix(e.target.value.toUpperCase())}
        margin="normal"
        variant="outlined"
        InputProps={{ sx: { bgcolor: "#fff" } }}
        helperText="A short code to identify Student Id"
      /> */}
      <TextField
  fullWidth
  label="Prefix"
  placeholder="e.g., ADM"
  value={studentPrefixId}
  onChange={(e) => {
    const input = e.target.value.toUpperCase();
    if (/^[A-Z]{0,3}$/.test(input)) {
      setPrefix(input);
    }
  }}
  margin="normal"
  variant="outlined"
  InputProps={{
    sx: {
      bgcolor: isPrefixDisabled ? "#f5f5f5" : "#fff", // light grey if disabled
    },
  }}
  helperText="A short code to identify Student Id"
  disabled={isPrefixDisabled}
/>



    </Tooltip>

    <Tooltip title="Starting number for ID generation. e.g., 100, 500, etc.">
     
      <TextField
  fullWidth
  label="Admission Sequence Number"
  placeholder="e.g., 100"
  type="number"
  value={sequenceNumber}
  onChange={(e) => {
    const value = e.target.value;
    if (value === "" || parseInt(value) > 0) {
      setSequenceNumber(value);
    }
  }}
  inputProps={{ min: 1 }} // prevents using arrows to go below 1
  margin="normal"
  variant="outlined"
  InputProps={{ sx: { bgcolor: "#fff" } }}
  helperText="This number will increment for each new Student Registered"
/>

    </Tooltip>
  </DialogContent>

  <DialogActions sx={{ justifyContent: "space-between", p: 2 }}>
    <Button onClick={handleClose} variant="outlined" color="primary">
      Cancel
    </Button>
    <Button
      onClick={handlePrefixSubmit}
      variant="contained"
      sx={{
        backgroundColor: "#3C3972",
        "&:hover": { backgroundColor: "#2c2958" },
        color: "#fff",
      }}
    >
      Save Settings
    </Button>
  </DialogActions>
</Dialog>






    </Box>

                {currentTab === 0 && (
                  <Box>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
  {/* Left-aligned box */}
  <Box>
    <Typography
      variant="h6"
      fontSize={20}
      sx={{ fontWeight: "bold" }}
    >
      Basic Details
    </Typography>
  </Box>

  {/* Right-aligned box */}
  <Box display="flex" alignItems="center" gap={2}>
    {/* //excel upload buttons  */}
        <Button
          variant="contained"
          component="label"
          startIcon={<UploadFileIcon />}
          sx={{ textTransform: "none",  backgroundColor: "#3C3972" ,":hover": {
      backgroundColor: "#3C3972", // keep same as default
    },}}
        >
          {fileName ? fileName : "Upload Excel"}
          <input type="file" accept=".xlsx, .xls" hidden onChange={handleFileUpload} />
        </Button>
      <Button
  variant="outlined"
  color="primary"
  onClick={handleExcelSubmit}
  disabled={excelData.length === 0}
>
  {excelloading ? (
    <>
      <CircularProgress size={20} color="inherit" style={{ marginRight: 8 }} />
      Processing...
    </>
  ) : (
    "Submit"
  )}
</Button>

  </Box>


</Box>



                    <Box
                      display="grid"
                      gap="15px"
                      gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                    >
                      <StyledTextField
                        fullWidth
                        type="text"
                        label="First Name*"
                        onBlur={handleBlur}
                        onChange={(e) => {
                           const lettersOnly = e.target.value.replace(/[^A-Za-z\s]/g, '');
                          const upperCaseValue = lettersOnly.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.firstName}
                        name="firstName"
                        autoComplete="off"
                        error={!!touched.firstName && !!errors.firstName}
                        helperText={touched.firstName && errors.firstName}
                      />

                      <StyledTextField
                        fullWidth
                        type="text"
                        label="Last Name*"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          const lettersOnly = e.target.value.replace(/[^A-Za-z\s]/g, '');
                          const upperCaseValue = lettersOnly.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.lastName}
                        name="lastName"
                        autoComplete="off"
                        error={!!touched.lastName && !!errors.lastName}
                        helperText={touched.lastName && errors.lastName}
                      />

                      <FormControl
                        fullWidth
                        // error={touched.gender && !!errors.gender}
                      >
                        <InputLabel htmlFor="gender">Gender</InputLabel>
                        <Select
                          id="gender"
                          name="gender"
                          value={values.gender}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          label="Gender"
                          inputProps={{
                            id: "gender",
                          }}
                        >
                          {genderOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>
                          {touched.gender && errors.gender}
                        </FormHelperText>
                      </FormControl>

                      <StyledTextField
                        fullWidth
                        type="date"
                        label="Admission Date"
                        InputLabelProps={{ shrink: true }}
                        onBlur={handleBlur}
                        handleChange={Formik.handleChange} // Pass handleChange properly
                        onChange={handleChange}
                        value={values.admissionDate}
                        name="admissionDate"
                        autoComplete="off"
                        // error={
                        //   !!touched.admissionDate && !!errors.admissionDate
                        // }
                        helperText={
                          touched.admissionDate && errors.admissionDate
                        }
                      />

                       <StyledTextField
                        fullWidth
                        type="number"
                        label="Admission No"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.customAdmissionNumber}
                        name="customAdmissionNumber"
                        autoComplete="off"
                       placeholder="Admission Number"
                      />


                      <TextField
                        select
                        fullWidth
                        label="Joining Year"
                        name="studentJoinedYear"
                        value={values.studentJoinedYear}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        autoComplete="off"
                        // error={
                        //   !!touched.studentJoinedYear &&
                        //   !!errors.studentJoinedYear
                        // }
                        helperText={
                          touched.studentJoinedYear && errors.studentJoinedYear
                        }
                      >
                        {academicYears.map((year) => (
                          <MenuItem key={year} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                      </TextField>

                      <StyledTextField
                        fullWidth
                        type="date"
                        label="Date of Birth"
                        InputLabelProps={{ shrink: true }}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.dob}
                        name="dob"
                        autoComplete="off"
                        error={!!touched.dob && !!errors.dob}
                        helperText={touched.dob && errors.dob}
                      />

                      <StyledTextField
  fullWidth
  type="text"
  label="Religion"
  onBlur={handleBlur}
  onChange={(e) => {
    // Remove everything except letters and spaces
    const lettersOnly = e.target.value.replace(/[^A-Za-z\s]/g, '');

    handleChange({
      target: {
        name: e.target.name,
        value: lettersOnly,
      },
    });
  }}
  value={values.religion}
  name="religion"
  autoComplete="off"
  error={!!touched.religion && !!errors.religion}
  helperText={touched.religion && errors.religion}
/>

                     <StyledTextField
  fullWidth
  type="text"
  label="Caste"
  onBlur={handleBlur}
  onChange={(e) => {
    // allow only letters and spaces
    const lettersOnly = e.target.value.replace(/[^A-Za-z\s-]/g, '');

    handleChange({
      target: {
        name: e.target.name,
        value: lettersOnly,
      },
    });
  }}
  value={values.caste}
  name="caste"
  autoComplete="off"
  error={!!touched.caste && !!errors.caste}
  helperText={touched.caste && errors.caste}
/>


                      <FormControl fullWidth>
                        <InputLabel>Blood Group</InputLabel>
                        <Select
                          label="Blood Group"
                          value={values.bloodGroup}
                          onChange={handleChange}
                          name="bloodGroup"
                          onBlur={handleBlur}
                          error={!!touched.bloodGroup && !!errors.bloodGroup}
                        >
                          <MenuItem value="A+">A+</MenuItem>
                          <MenuItem value="A-">A-</MenuItem>
                          <MenuItem value="B+">B+</MenuItem>
                          <MenuItem value="B-">B-</MenuItem>
                          <MenuItem value="O+">O+</MenuItem>
                          <MenuItem value="O-">O-</MenuItem>
                          <MenuItem value="AB+">AB+</MenuItem>
                          <MenuItem value="AB-">AB-</MenuItem>
                          <MenuItem value="AB-">None</MenuItem>
                        </Select>
                        {touched.bloodGroup && errors.bloodGroup && (
                          <Typography color="error" variant="body2">
                            {errors.bloodGroup}
                          </Typography>
                        )}
                      </FormControl>

                      <FormControl fullWidth>
                        <InputLabel>Nationality</InputLabel>
                        <Select
                          label="Nationality"
                          value={values.nationality}
                          onChange={handleChange}
                          name="nationality"
                          onBlur={handleBlur}
                          error={!!touched.nationality && !!errors.nationality}
                        >
                          <MenuItem value="Indian">Indian</MenuItem>
                          <MenuItem value="Other">Other</MenuItem>
                        </Select>
                        {touched.nationality && errors.nationality && (
                          <Typography color="error" variant="body2">
                            {errors.nationality}
                          </Typography>
                        )}
                      </FormControl>
 <StyledTextField
                        fullWidth
                        type="text"
                        label="PEN"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.pen}
                        name="pen"
                        autoComplete="off"
                       placeholder="Permanent Education Number"
                      />



                      <FormControl fullWidth>
                        <InputLabel>Role</InputLabel>
                        <Select
                          label="Role"
                          value={values.role}
                          name="role"
                          disabled
                          onBlur={handleBlur}
                          error={!!touched.role && !!errors.role}
                          sx={{ backgroundColor: "#f0f0f0", color: "#6c757d" }} // Light gray background and muted text
                        >
                          <MenuItem value="STUDENT">STUDENT</MenuItem>
                        </Select>
                        {touched.role && errors.role && (
                          <Typography color="error" variant="body2">
                            {errors.role}
                          </Typography>
                        )}
                      </FormControl>

                      {/* {isPrincipal && ( // Show these only for Admin users
                        <>
                          <FormControl fullWidth>
                            <InputLabel>Select Admin</InputLabel>
                            <Select
                              value={selectedUsers}
                              onChange={(e) => setSelectedUsers(e.target.value)}
                              // name="userRoleName"
                              // onBlur={handleBlur}
                              label="Select Admin"
                              // error={!!touched.userRoleName && !!errors.userRoleName}
                            >
                              {users.map((user) => (
                                <MenuItem key={user.userId} value={user.userId}>
                                  {user.userId}-{user.firstName} {user.lastName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </>
                      )} */}
                    </Box>
                    <Box display="flex" justifyContent="flex-end" marginTop={3}>
                      <Button
                        variant="contained"
                        style={{ width: "100px", backgroundColor: "#3C3972" }}
                        onClick={async () => {
                          // Set all fields as touched to trigger error messages
                          setTouched({
                            // surName:true,
                            firstName: true,
                            lastName: true,
                            religion: true,
                            // gender: true,
                            // dob: true,
                            // admissionDate: true,
                            // studentJoinedYear: true,
                            caste: true,
                            bloodGroup: true,
                            nationality: true,

                            // Add other fields similarly
                          });
                          const errors = await validateForm();
                          if (!Object.keys(errors).length) {
                            setCurrentTab(1);
                          }
                        }}
                      >
                        Next
                      </Button>
                    </Box>
                  </Box>
                )}

                {currentTab === 1 && (
                  <Box>
                    <Typography
                      variant="h6"
                      fontSize={20}
                      sx={{ fontWeight: "bold" }}
                      marginBottom={2}
                    >
                      Personal Details
                    </Typography>

                    <Box
                      display="grid"
                      gap="15px"
                      gridTemplateColumns="repeat(2, minmax(0, 1fr))"
                    >
                      <StyledTextField
  fullWidth
  type="text" // keep text to control input
  label="Aadhar Number"
  onBlur={handleBlur}
  onChange={(e) => {
    // Allow only digits
    let value = e.target.value.replace(/\D/g, '');
    // Restrict to 12 digits max
    if (value.length > 12) {
      value = value.slice(0, 12);
    }

    handleChange({
      target: {
        name: e.target.name,
        value: value,
      },
    });
  }}
  value={values.aadharNumber}
  name="aadharNumber"
  inputProps={{ maxLength: 12 }} // also prevents pasting more than 12
  autoComplete="off"
  error={!!touched.aadharNumber && !!errors.aadharNumber}
  helperText={touched.aadharNumber && errors.aadharNumber}
/>

                      <StyledTextField
  fullWidth
  type="text" // use text to control input properly
  label="Father Contact No*"
  onBlur={handleBlur}
  onChange={(e) => {
    // Allow only digits
    let value = e.target.value.replace(/\D/g, '');
    // Limit to 12 digits total (including 91)
    if (value.length > 10) {
      value = value.slice(0, 10);
    }

    handleChange({
      target: {
        name: e.target.name,
        value: value,
      },
    });
  }}
  value={values.primaryContact}
  name="primaryContact"
  autoComplete="off"
  inputProps={{ maxLength: 10 }}
  error={!!touched.primaryContact && !!errors.primaryContact}
  helperText={touched.primaryContact && errors.primaryContact}
  InputProps={{
    startAdornment: (
      <InputAdornment position="start">+91</InputAdornment>
    ),
  }}
/>


                     <StyledTextField
  fullWidth
  type="text" // use text to control input properly
  label="Mother Contact No"
  onBlur={handleBlur}
  onChange={(e) => {
    // Allow only digits
    let value = e.target.value.replace(/\D/g, '');
    // Limit to 10 digits
    if (value.length > 10) {
      value = value.slice(0, 10);
    }

    handleChange({
      target: {
        name: e.target.name,
        value: value,
      },
    });
  }}
  value={values.alternateContact}
  name="alternateContact"
  autoComplete="off"
  inputProps={{ maxLength: 10 }}
  error={!!touched.alternateContact && !!errors.alternateContact}
  helperText={touched.alternateContact && errors.alternateContact}
  InputProps={{
    startAdornment: (
      <InputAdornment position="start">+91</InputAdornment>
    ),
  }}
/>

                      <StyledTextField
                        fullWidth
                        type="text"
                        label="Address"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.address}
                        name="address"
                        autoComplete="off"
                        error={!!touched.address && !!errors.address}
                        helperText={touched.address && errors.address}
                      />





{board === "SSC" && (
  <>
  <FormControl fullWidth>
  <InputLabel>Student Joined Class</InputLabel>
  <Select
    label="Student Joined Class"
    name="studentJoinedClass"
    value={values.studentJoinedClass}
    onChange={handleChange}
    //  onChange={(e) => {
    //       const selected = e.target.value;
    //       setSscSelectedClass(selected);
    //       const sections = sscClassSectionMap[selected] ? Array.from(sscClassSectionMap[selected]) : [];
    //       setSscSectionOptions(sections);
    //       setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0] || "");
    //     }}
    onBlur={handleBlur}
     error={!!touched.studentJoinedClass && !!errors.studentJoinedClass}
  >
    {sscClassOptions.length > 0 ? (
      sscClassOptions.map((cls) => (
        <MenuItem key={cls} value={cls}>
          {cls}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No classes available</MenuItem>
    )}
  </Select>
   {touched.studentJoinedClass && errors.studentJoinedClass && (
                          <Typography color="error" variant="body2">
                            {errors.studentJoinedClass}
                          </Typography>
                        )}
 
</FormControl>

   <FormControl size="medium" fullWidth>
  <InputLabel id="class-select-label">Student Present Class*</InputLabel>
  <Select
    labelId="class-select-label"
    // value={sscSelectedClass}
    // onChange={(e) => setSscSelectedClass(e.target.value)}
    label="Student Present Class*"

    name="romanNumberClass"
    value={values.romanNumberClass}
    // onChange={(e) => {
    //   const selected = e.target.value;
    //   handleChange(e); // updates Formik state
    //   setSscSelectedClass(selected); // optional: update your component state if used elsewhere
    // }}
    onChange={(e) => {
      const selected = e.target.value;

      // ✅ Formik handleChange
      handleChange(e);

      // ✅ Your custom logic
      setSscSelectedClass(selected);
      const sections = sscClassSectionMap[selected]
        ? Array.from(sscClassSectionMap[selected])
        : [];
      setSscSectionOptions(sections);
      setSscSelectedSection(
        sections.includes("Section-A") ? "Section-A" : sections[0] || ""
      );
    }}
    onBlur={handleBlur}
     error={!!touched.romanNumberClass && !!errors.romanNumberClass}
  >
    {sscClassOptions.length > 0 ? (
      sscClassOptions.map((cls) => (
        <MenuItem key={cls} value={cls}>
          {cls}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No classes available</MenuItem>
    )}
  </Select>
   {touched.romanNumberClass && errors.romanNumberClass && (
                          <Typography color="error" variant="body2">
                            {errors.romanNumberClass}
                          </Typography>
                        )}
</FormControl>



<FormControl size="medium" fullWidth>
  <InputLabel id="section-select-label">Select Section*</InputLabel>
  <Select
    labelId="section-select-label"
    // value={sscSelectedSection}
    // onChange={(e) => setSscSelectedSection(e.target.value)}
    label="Select Section*"

    name="sections"
        value={values.sections}
        onChange={(e) => {
          const selected = e.target.value;
          handleChange(e); // updates Formik state
          setSscSelectedSection(selected); // optional: update your component state if used elsewhere
        }}
        onBlur={handleBlur}
     error={!!touched.sections && !!errors.sections}
  >
    {sscSectionOptions.length > 0 ? (
      sscSectionOptions.map((section) => (
        <MenuItem key={section} value={section}>
          {section}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No sections available</MenuItem>
    )}
  </Select>
   {touched.sections && errors.sections && (
                          <Typography color="error" variant="body2">
                            {errors.sections}
                          </Typography>
                        )}
</FormControl>

  </>
)}


{board === "INTERMEDIATE" && (
  <>
   <FormControl fullWidth>
  <InputLabel>Student Joined Class</InputLabel>
  <Select
    label="Student Joined Class"
    name="studentJoinedClass"
    value={values.studentJoinedClass}
    onChange={handleChange}
    onBlur={handleBlur}
    // error={!!touched.studentJoinedClass && !!errors.studentJoinedClass}
     error={!!touched.studentJoinedClass && !!errors.studentJoinedClass}
  >
   
       <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
       <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
   
  </Select>
  {touched.studentJoinedClass && errors.studentJoinedClass && (
                          <Typography color="error" variant="body2">
                            {errors.studentJoinedClass}
                          </Typography>
                        )}
 
 
</FormControl>

    <FormControl size="medium" fullWidth>
      <InputLabel id="intermediate-class-select-label">Select Admission Class*</InputLabel>
      <Select
        labelId="intermediate-class-select-label"
        label="Select Admission Class*"
        name="romanNumberClass"
        value={values.romanNumberClass}
        onChange={(e) => {
          const selected = e.target.value;
          handleChange(e); // updates Formik state
          setInterSelectedClass(selected); // optional: update your component state if used elsewhere
        }}
        onBlur={handleBlur}
         error={!!touched.romanNumberClass && !!errors.romanNumberClass}
      >
        <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
        <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
      </Select>
       {touched.romanNumberClass && errors.romanNumberClass && (
                          <Typography color="error" variant="body2">
                            {errors.romanNumberClass}
                          </Typography>
                        )}
    </FormControl>
   

    <FormControl fullWidth size="medium">
  <InputLabel id="course-type-label">Select Course*</InputLabel>
  <Select
    labelId="course-type-label"
    // value={selectedCourseType}

    name="course"
    value={values.course}
    onChange={(e) => {
      const selected = e.target.value;
      handleChange(e); // updates Formik state
      setSelectedCourseType(selected); // optional: update your component state if used elsewhere
    }}
    onBlur={handleBlur}

    // onChange={(e) => setSelectedCourseType(e.target.value)}
    label="Select Course*"
  >
    {courseOptions.length > 0 ? (
      courseOptions.map((course, index) => (
        <MenuItem key={index} value={course}>
          {course}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No courses available</MenuItem>
    )}
  </Select>
</FormControl>



    <FormControl fullWidth size="medium">
  <InputLabel id="intermediate-section-select-label">Select Section*</InputLabel>
  <Select
    labelId="intermediate-section-select-label"
    // value={interSelectedSection}
    // onChange={(e) => setInterSelectedSection(e.target.value)}
    label="Select Section*"

    name="sections"
        value={values.sections}
        onChange={(e) => {
          const selected = e.target.value;
          handleChange(e); // updates Formik state
          setInterSelectedSection(selected); // optional: update your component state if used elsewhere
        }}
        onBlur={handleBlur}
         error={!!touched.sections && !!errors.sections}
  >
    {interSectionOptions.length > 0 ? (
      interSectionOptions.map((section, index) => (
        <MenuItem key={index} value={section}>
          {section}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No sections available for selected Year and Course</MenuItem>
    )}
  </Select>
    {touched.sections && errors.sections && (
                          <Typography color="error" variant="body2">
                            {errors.sections}
                          </Typography>
                        )}
</FormControl>

  </>
)}

                      <StyledTextField
  fullWidth
  type="text"
  label="Previous Studied"
  onBlur={handleBlur}
  onChange={(e) => {
    // Allow only letters and spaces
    const lettersOnly = e.target.value.replace(/[^A-Za-z\s]/g, '');

    handleChange({
      target: {
        name: e.target.name,
        value: lettersOnly,
      },
    });
  }}
  value={values.previousSchool}
  name="previousSchool"
  autoComplete="off"
  // error={!!touched.previousSchool && !!errors.previousSchool}
  // helperText={touched.previousSchool && errors.previousSchool}
/>

                     <StyledTextField
  fullWidth
  type="text"
  label="Mole-1"
  onBlur={handleBlur}
  onChange={(e) => {
    // Allow only letters and spaces
    const lettersOnly = e.target.value.replace(/[^A-Za-z\s]/g, '');

    handleChange({
      target: {
        name: e.target.name,
        value: lettersOnly,
      },
    });
  }}
  value={values.mole1}
  name="mole1"
  autoComplete="off"
  error={!!touched.mole1 && !!errors.mole1}
  helperText={touched.mole1 && errors.mole1}
/>

                     <StyledTextField
  fullWidth
  type="text"
  label="Mole-2"
  onBlur={handleBlur}
  onChange={(e) => {
    // Allow only letters and spaces
    const lettersOnly = e.target.value.replace(/[^A-Za-z\s]/g, '');

    handleChange({
      target: {
        name: e.target.name,
        value: lettersOnly,
      },
    });
  }}
  value={values.mole2}
  name="mole2"
  autoComplete="off"
  error={!!touched.mole2 && !!errors.mole2}
  helperText={touched.mole2 && errors.mole2}
/>

                    </Box>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      marginTop={3}
                    >
                      <Button
                        variant="contained"
                        style={{ width: "100px", backgroundColor: "#3C3972" }}
                        onClick={() => setCurrentTab(0)}
                      >
                        Previous
                      </Button>
                      <Button
                        variant="contained"
                        style={{ width: "100px", backgroundColor: "#3C3972" }}
                        onClick={async () => {
                          // Set all fields as touched to trigger error messages
                          setTouched({
                            // panNumber: true,
                            primaryContact: true,
                            aadharNumber: true,
                            address: true,
                            romanNumberClass: true,
                            studentJoinedClass: true,
                            sections: true,
                            // previousSchool: true,
                            mole1: true,
                            mole2: true,
                            alternateContact: true,

                            // Add other fields similarly
                          });
                          const errors = await validateForm();
                          if (!Object.keys(errors).length) {
                            setCurrentTab(2);
                          }
                        }}
                      >
                        Next
                      </Button>
                    </Box>
                  </Box>
                )}

                {currentTab === 2 && (
                  <Box>
                    <Typography
                      variant="h6"
                      fontSize={20}
                      sx={{ fontWeight: "bold" }}
                      marginBottom={2}
                    >
                      Family Details
                    </Typography>

                    <Box
                      display="grid"
                      gap="15px"
                      gridTemplateColumns="repeat(2, minmax(0, 1fr))"
                    >
                      <StyledTextField
                        fullWidth
                        type="text"
                        label="Father First Name"
                        onBlur={handleBlur}
                        onChange={(e) => {
                           const lettersOnly = e.target.value.replace(/[^A-Za-z\s]/g, '');
                          const upperCaseValue = lettersOnly.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.fathersFirstName}
                        name="fathersFirstName"
                        autoComplete="off"
                        error={
                          !!touched.fathersFirstName &&
                          !!errors.fathersFirstName
                        }
                        helperText={
                          touched.fathersFirstName && errors.fathersFirstName
                        }
                      />

                      <StyledTextField
                        fullWidth
                        type="text"
                        label="Father Last Name"
                        onBlur={handleBlur}
                        onChange={(e) => {
                           const lettersOnly = e.target.value.replace(/[^A-Za-z\s]/g, '');
                          const upperCaseValue = lettersOnly.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.fathersLastName}
                        name="fathersLastName"
                        autoComplete="off"
                        error={
                          !!touched.fathersLastName && !!errors.fathersLastName
                        }
                        helperText={
                          touched.fathersLastName && errors.fathersLastName
                        }
                      />

                      <StyledTextField
                        fullWidth
                        type="text"
                        label="Father Qualification"
                        onBlur={handleBlur}
                        onChange={(e) => {
                           const lettersOnly = e.target.value.replace(/[^A-Za-z\s]/g, '');
                          const upperCaseValue = lettersOnly.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.fathersQualification}
                        name="fathersQualification"
                        autoComplete="off"
                        error={
                          !!touched.fathersQualification &&
                          !!errors.fathersQualification
                        }
                        helperText={
                          touched.fathersQualification &&
                          errors.fathersQualification
                        }
                      />
                      <StyledTextField
                        fullWidth
                        type="text"
                        label="Father Occupation"
                        onBlur={handleBlur}
                        onChange={(e) => {
                           const lettersOnly = e.target.value.replace(/[^A-Za-z\s]/g, '');
                          const upperCaseValue = lettersOnly.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.fathersOccupation}
                        name="fathersOccupation"
                        autoComplete="off"
                        error={
                          !!touched.fathersOccupation &&
                          !!errors.fathersOccupation
                        }
                        helperText={
                          touched.fathersOccupation && errors.fathersOccupation
                        }
                      />

                      <StyledTextField
                        fullWidth
                        type="email"
                        label="Father Email-Id"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.fathersMailId}
                        name="fathersMailId"
                        autoComplete="off"
                        error={
                          !!touched.fathersMailId && !!errors.fathersMailId
                        }
                        helperText={
                          touched.fathersMailId && errors.fathersMailId
                        }
                      />

                      <StyledTextField
                        fullWidth
                        type="text"
                        label="Mother First Name"
                        onBlur={handleBlur}
                        onChange={(e) => {
                           const lettersOnly = e.target.value.replace(/[^A-Za-z\s]/g, '');
                          const upperCaseValue = lettersOnly.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.mothersFirstName}
                        name="mothersFirstName"
                        autoComplete="off"
                        error={
                          !!touched.mothersFirstName &&
                          !!errors.mothersFirstName
                        }
                        helperText={
                          touched.mothersFirstName && errors.mothersFirstName
                        }
                      />

                      <StyledTextField
                        fullWidth
                        type="text"
                        label="Mother Last Name"
                        onBlur={handleBlur}
                        onChange={(e) => {
                           const lettersOnly = e.target.value.replace(/[^A-Za-z\s]/g, '');
                          const upperCaseValue = lettersOnly.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.mothersLastName}
                        name="mothersLastName"
                        autoComplete="off"
                        error={
                          !!touched.mothersLastName && !!errors.mothersLastName
                        }
                        helperText={
                          touched.mothersLastName && errors.mothersLastName
                        }
                      />
                      <StyledTextField
                        fullWidth
                        type="text"
                        label="Mother Qualification"
                        onBlur={handleBlur}
                        onChange={(e) => {
                           const lettersOnly = e.target.value.replace(/[^A-Za-z\s]/g, '');
                          const upperCaseValue = lettersOnly.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.mothersQualification}
                        name="mothersQualification"
                        autoComplete="off"
                        error={
                          !!touched.mothersQualification &&
                          !!errors.mothersQualification
                        }
                        helperText={
                          touched.mothersQualification &&
                          errors.mothersQualification
                        }
                      />
                      <StyledTextField
                        fullWidth
                        type="text"
                        label="Mother Occupation"
                        onBlur={handleBlur}
                        onChange={(e) => {
                           const lettersOnly = e.target.value.replace(/[^A-Za-z\s]/g, '');
                          const upperCaseValue = lettersOnly.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.mothersOccupation}
                        name="mothersOccupation"
                        autoComplete="off"
                        error={
                          !!touched.mothersOccupation &&
                          !!errors.mothersOccupation
                        }
                        helperText={
                          touched.mothersOccupation && errors.mothersOccupation
                        }
                      />

                      <StyledTextField
                        fullWidth
                        type="email"
                        label="Mother Email-Id"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.mothersMailId}
                        name="mothersMailId"
                        autoComplete="off"
                        error={
                          !!touched.mothersMailId && !!errors.mothersMailId
                        }
                        helperText={
                          touched.mothersMailId && errors.mothersMailId
                        }
                      />
                    </Box>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      marginTop={3}
                    >
                      <Button
                        variant="contained"
                        style={{ width: "100px", backgroundColor: "#3C3972" }}
                        onClick={() => setCurrentTab(1)}
                      >
                        Previous
                      </Button>
                      <Button
                        variant="contained"
                        style={{ width: "100px", backgroundColor: "#3C3972" }}
                        onClick={async () => {
                          // Set all fields as touched to trigger error messages
                          setTouched({
                            fathersFirstName: true,
                            fathersLastName: true,
                            mothersFirstName: true,
                            mothersLastName: true,
                            fathersQualification: true,
                            mothersQualification: true,
                            fathersOccupation: true,
                            mothersOccupation: true,
                            fathersMailId: true,
                            mothersMailId: true,

                            // Add other fields similarly
                          });
                          const errors = await validateForm();
                          if (!Object.keys(errors).length) {
                            setCurrentTab(3);
                          }
                        }}
                      >
                        Next
                      </Button>
                    </Box>
                  </Box>
                )}
                {currentTab === 3 && (
                  <Box>
                    <Typography
                      variant="h6"
                      fontSize={20}
                      sx={{ fontWeight: "bold" }}
                      marginBottom={2}
                    >
                      Upload Documents
                    </Typography>
                    <Box
                      display="grid"
                      gap="30px"
                      gridTemplateColumns="repeat(2, minmax(0, 1fr))"
                    >
                      <StyledTextField
                        fullWidth
                        type="file"
                        InputLabelProps={{ shrink: true }}
                        label="PassPhoto (JPG/JPEG/PNG)"
                        onBlur={handleBlur}
                        onChange={(e) =>
                          setFieldValue("passPhoto", e.currentTarget.files[0])
                        }
                        name="passPhoto"
                        error={!!touched.passPhoto && !!errors.passPhoto}
                        helperText={touched.passPhoto && errors.passPhoto}
                      />
                      <StyledTextField
                        fullWidth
                        type="file"
                        InputLabelProps={{ shrink: true }}
                        label="Aadhaar Card"
                        onBlur={handleBlur}
                        onChange={(e) =>
                          setFieldValue("aadharCard", e.currentTarget.files[0])
                        }
                        name="aadharCard"
                        error={!!touched.aadharCard && !!errors.aadharCard}
                        helperText={touched.aadharCard && errors.aadharCard}
                      />
                      <StyledTextField
                        fullWidth
                        type="file"
                        InputLabelProps={{ shrink: true }}
                        label="Previous TC"
                        onBlur={handleBlur}
                        onChange={(e) =>
                          setFieldValue("previousTc", e.currentTarget.files[0])
                        }
                        name="previousTc"
                        error={!!touched.previousTc && !!errors.previousTc}
                        helperText={touched.previousTc && errors.previousTc}
                      />
                      <StyledTextField
                        fullWidth
                        type="file"
                        InputLabelProps={{ shrink: true }}
                        label="Bonafide"
                        onBlur={handleBlur}
                        onChange={(e) =>
                          setFieldValue("bonafide", e.currentTarget.files[0])
                        }
                        name="bonafide"
                        error={!!touched.bonafide && !!errors.bonafide}
                        helperText={touched.bonafide && errors.bonafide}
                      />
                      <StyledTextField
                        fullWidth
                        type="file"
                        InputLabelProps={{ shrink: true }}
                        label="DOB Certificate"
                        onBlur={handleBlur}
                        onChange={(e) =>
                          setFieldValue(
                            "dobCertificate",
                            e.currentTarget.files[0]
                          )
                        }
                        name="dobCertificate"
                        error={
                          !!touched.dobCertificate && !!errors.dobCertificate
                        }
                        helperText={
                          touched.dobCertificate && errors.dobCertificate
                        }
                      />

                      {/* <StyledTextField
                        fullWidth
                        type="number"
                        label="Admission Fees"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          const upperCaseValue = e.target.value.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.admissionFee}
                        name="admissionFee"
                        autoComplete="off"
                        error={!!touched.admissionFee && !!errors.admissionFee}
                        helperText={touched.admissionFee && errors.admissionFee}
                      /> */}
                      <StyledTextField
                        fullWidth
                        type="number"
                        label="Admission Fees"
                        onBlur={handleBlur}
                        onChange={handleChange}        // ⬅️  no uppercase
                        value={values.admissionFee}
                        name="admissionFee"
                        autoComplete="off"
                        error={!!touched.admissionFee && !!errors.admissionFee}
                        helperText={touched.admissionFee && errors.admissionFee}
                      />
                      <StyledTextField
                        fullWidth
                        type="number"
                        label="School Fees"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.tutionFee}
                        name="tutionFee"
                        autoComplete="off"
                        error={!!touched.tutionFee && !!errors.tutionFee}
                        helperText={touched.tutionFee && errors.tutionFee}
                      />

                      {/* <StyledTextField
                        fullWidth
                        type="number"
                        label="School Fees"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          const upperCaseValue = e.target.value.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.tutionFee}
                        name="tutionFee"
                        autoComplete="off"
                        error={!!touched.tutionFee && !!errors.tutionFee}
                        helperText={touched.tutionFee && errors.tutionFee}
                      /> */}
                    </Box>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      marginTop={3}
                    >
                      <Button
                        variant="contained"
                        style={{
                          width: "100px",
                          height: "35px",
                          backgroundColor: "#3C3972",
                        }}
                        onClick={() => setCurrentTab(2)}
                      >
                        Previous
                      </Button>
                      <StyledButton
                        type="submit"
                        variant="contained"
                        style={{ width: "130px", backgroundColor: "#3C3972" }}
                        disabled={loading}
                        onClick={async (e) => {
                          e.preventDefault(); // Prevent default form submission
                          setTouched({
                            // passPhoto: true,
                            tutionFee: true,
                            admissionFee: true,
                          });

                          // Trigger form validation
                          const errors = await validateForm();

                          if (Object.keys(errors).length === 0) {
                            // No errors, submit the form
                            handleSubmit(values); // Ensure values are passed
                          }
                        }}
                      >
                        {loading ? (
                          <FacebookCircularProgress
                            size={24}
                            sx={{ color: "#fff" }}
                          />
                        ) : (
                          "Submit The Form"
                        )}
                      </StyledButton>
                    </Box>
                  </Box>
                )}
              </Card>
            </Box>
          </form>
          );
        }}
      </Formik>
      <ToastContainer />
    </Box>
  );
};

export default NewAdmissionForm;